import React, { Fragment, useEffect, useState } from 'react'
import PiesAge from './PiesAge';


const AgeResults = ({ results }) => {

    const [fiveTwelveIn, setFiveTwelveIn] = useState(0)
    const [fiveTenIn, setFiveTenIn] = useState(0)
    const [fiveEightIn, setFiveEightIn] = useState(0)
    const [fiveSixIn, setFiveSixIn] = useState(0)
    const [fiveFourIn, setFiveFourIn] = useState(0)

    const [fiveTwelveOut, setFiveTwelveOut] = useState(0)
    const [fiveTenOut, setFiveTenOut] = useState(0)
    const [fiveEightOut, setFiveEightOut] = useState(0)
    const [fiveSixOut, setFiveSixOut] = useState(0)
    const [fiveFourOut, setFiveFourOut] = useState(0)




    useEffect(() => {
        results.forEach((result, i) => {
            if (result.sequenceContext === "Etage R+5") {
                result.results.forEach((res, i) => {
                    if (res.resource.attributes[0].quantity === "8.5") {
                        setFiveTwelveIn(res.personalData.nbHoursHomeCovid)
                        setFiveTwelveOut(res.personalData.nbHoursHome)
                    } else if (res.resource.attributes[0].quantity === "10") {
                        setFiveTenIn(res.personalData.nbHoursHomeCovid)
                        setFiveTenOut(res.personalData.nbHoursHome)
                    } else if (res.resource.attributes[0].quantity === "12.5") {
                        setFiveEightIn(res.personalData.nbHoursHomeCovid)
                        setFiveEightOut(res.personalData.nbHoursHome)
                    } else if (res.resource.attributes[0].quantity === "16.5") {
                        setFiveSixIn(res.personalData.nbHoursHomeCovid)
                        setFiveSixOut(res.personalData.nbHoursHome)
                    } else if (res.resource.attributes[0].quantity === "25") {
                        setFiveFourIn(res.personalData.nbHoursHomeCovid)
                        setFiveFourOut(res.personalData.nbHoursHome)
                    }
                })
            }
        }
        )
    }, [results])

    const pieR5R12In = [
        { name: '< 2 heures', value: fiveTwelveIn.l2 / fiveTwelveIn.total * 100 },
        { name: '2 à 4 heures', value: fiveTwelveIn.f2t4 / fiveTwelveIn.total * 100 },
        { name: '4 à 6 heures', value: fiveTwelveIn.f4t6 / fiveTwelveIn.total * 100 },
        { name: '6 à 8 heures', value: fiveTwelveIn.f6t8 / fiveTwelveIn.total * 100 },
        { name: '> 8 heures', value: fiveTwelveIn.m8 / fiveTwelveIn.total * 100 },
    ]

    const pieR5R12Out = [
        { name: '< 2 heures', value: fiveTwelveOut.l2 / fiveTwelveOut.total * 100 },
        { name: '2 à 4 heures', value: fiveTwelveOut.f2t4 / fiveTwelveOut.total * 100 },
        { name: '4 à 6 heures', value: fiveTwelveOut.f4t6 / fiveTwelveOut.total * 100 },
        { name: '6 à 8 heures', value: fiveTwelveOut.f6t8 / fiveTwelveOut.total * 100 },
        { name: '> 8 heures', value: fiveTwelveOut.m8 / fiveTwelveOut.total * 100 },
    ]

    const pieR5R10In = [
        { name: '< 2 heures', value: fiveTenIn.l2 / fiveTenIn.total * 100 },
        { name: '2 à 4 heures', value: fiveTenIn.f2t4 / fiveTenIn.total * 100 },
        { name: '4 à 6 heures', value: fiveTenIn.f4t6 / fiveTenIn.total * 100 },
        { name: '6 à 8 heures', value: fiveTenIn.f6t8 / fiveTenIn.total * 100 },
        { name: '> 8 heures', value: fiveTenIn.m8 / fiveTenIn.total * 100 },
    ]

    const pieR5R10Out = [
        { name: '< 2 heures', value: fiveTenOut.l2 / fiveTenOut.total * 100 },
        { name: '2 à 4 heures', value: fiveTenOut.f2t4 / fiveTenOut.total * 100 },
        { name: '4 à 6 heures', value: fiveTenOut.f4t6 / fiveTenOut.total * 100 },
        { name: '6 à 8 heures', value: fiveTenOut.f6t8 / fiveTenOut.total * 100 },
        { name: '> 8 heures', value: fiveTenOut.m8 / fiveTenOut.total * 100 },
    ]

    const pieR5R8In = [
        { name: '< 2 heures', value: fiveEightIn.l2 / fiveEightIn.total * 100 },
        { name: '2 à 4 heures', value: fiveEightIn.f2t4 / fiveEightIn.total * 100 },
        { name: '4 à 6 heures', value: fiveEightIn.f4t6 / fiveEightIn.total * 100 },
        { name: '6 à 8 heures', value: fiveEightIn.f6t8 / fiveEightIn.total * 100 },
        { name: '> 8 heures', value: fiveEightIn.m8 / fiveEightIn.total * 100 },
    ]

    const pieR5R8Out = [
        { name: '< 2 heures', value: fiveEightOut.l2 / fiveEightOut.total * 100 },
        { name: '2 à 4 heures', value: fiveEightOut.f2t4 / fiveEightOut.total * 100 },
        { name: '4 à 6 heures', value: fiveEightOut.f4t6 / fiveEightOut.total * 100 },
        { name: '6 à 8 heures', value: fiveEightOut.f6t8 / fiveEightOut.total * 100 },
        { name: '> 8 heures', value: fiveEightOut.m8 / fiveEightOut.total * 100 },
    ]

    const pieR5R6In = [
        { name: '< 2 heures', value: fiveSixIn.l2 / fiveSixIn.total * 100 },
        { name: '2 à 4 heures', value: fiveSixIn.f2t4 / fiveSixIn.total * 100 },
        { name: '4 à 6 heures', value: fiveSixIn.f4t6 / fiveSixIn.total * 100 },
        { name: '6 à 8 heures', value: fiveSixIn.f6t8 / fiveSixIn.total * 100 },
        { name: '> 8 heures', value: fiveSixIn.m8 / fiveSixIn.total * 100 },
    ]

    const pieR5R6Out = [
        { name: '< 2 heures', value: fiveSixOut.l2 / fiveSixOut.total * 100 },
        { name: '2 à 4 heures', value: fiveSixOut.f2t4 / fiveSixOut.total * 100 },
        { name: '4 à 6 heures', value: fiveSixOut.f4t6 / fiveSixOut.total * 100 },
        { name: '6 à 8 heures', value: fiveSixOut.f6t8 / fiveSixOut.total * 100 },
        { name: '> 8 heures', value: fiveSixOut.m8 / fiveSixOut.total * 100 },
    ]

    const pieR5R4In = [
        { name: '< 2 heures', value: fiveFourIn.l2 / fiveFourIn.total * 100 },
        { name: '2 à 4 heures', value: fiveFourIn.f2t4 / fiveFourIn.total * 100 },
        { name: '4 à 6 heures', value: fiveFourIn.f4t6 / fiveFourIn.total * 100 },
        { name: '6 à 8 heures', value: fiveFourIn.f6t8 / fiveFourIn.total * 100 },
        { name: '> 8 heures', value: fiveFourIn.m8 / fiveFourIn.total * 100 },
    ]

    const pieR5R4Out = [
        { name: '< 2 heures', value: fiveFourOut.l2 / fiveFourOut.total * 100 },
        { name: '2 à 4 heures', value: fiveFourOut.f2t4 / fiveFourOut.total * 100 },
        { name: '4 à 6 heures', value: fiveFourOut.f4t6 / fiveFourOut.total * 100 },
        { name: '6 à 8 heures', value: fiveFourOut.f6t8 / fiveFourOut.total * 100 },
        { name: '> 8 heures', value: fiveFourOut.m8 / fiveFourOut.total * 100 },
    ]



    return (
        <Fragment>
            <PiesAge
                context="Votes des participants à R+5 selon le nombre d'heures passées par jour à leur domicile "
                pieR1R12={pieR5R12In}
                pieR5R12={pieR5R12Out}
                pieR1R10={pieR5R10In}
                pieR5R10={pieR5R10Out}
                pieR1R8={pieR5R8In}
                pieR5R8={pieR5R8Out}
                pieR1R6={pieR5R6In}
                pieR5R6={pieR5R6Out}
                pieR1R4={pieR5R4In}
                pieR5R4={pieR5R4Out}
                contextLeft='Hors période Covid'
                contextRight='Période Covid'
            />
        </Fragment>

    )
}

export default AgeResults
